import React from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	disableSave: boolean;
	handleCancelPriceChanges: () => void;
	handleSavePriceChanges: () => void;
}

export const PriceEditActions = (props: OwnProps) => {
	const { t } = useTranslation();

	return (
		<React.Fragment>
			<Button size={'small'} onClick={props.handleCancelPriceChanges}>
				{t('common:actions.cancel')}
			</Button>
			<Button
				size={'small'}
				variant="contained"
				color="primary"
				onClick={props.handleSavePriceChanges}
				disabled={props.disableSave}
			>
				{t('common:actions.save')}
			</Button>
		</React.Fragment>
	);
};

export default PriceEditActions;
